import React, { createContext, useContext, useState } from 'react';
import { Alert } from '../../components/ui/alert';
import { AnimatePresence } from 'framer-motion';
import { AlertTransition } from '../../components/ui/AlertTransition';
import '../../css/alert-animations.css';

const AlertContext = createContext({
    showAlert: () => {},
    hideAlert: () => {}
});

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);

    const showAlert = ({ title, description, variant = 'default', duration = 3000}) => {
        const id = Math.random().toString(36).substring(7);

        setAlerts(prev => [...prev, {id, title, description, variant}]);

        if (duration) {
            setTimeout(() => {
                hideAlert(id);
            }, duration);
        }

        return id;
    };

    const hideAlert = (id) => {
        setAlerts(prev => prev.filter(alert => alert.id !== id));
    };

    return (
        <AlertContext.Provider value={{ showAlert, hideAlert }}>
            {children}
            <div className='fixed top-4 right-4 z-50 space-y-2 w-96'>
                <AnimatePresence mode="sync">
                    {alerts.map(({id, title, description, variant}) => (
                        <AlertTransition key={id} id={id}>
                            <Alert 
                                variant={variant}
                                title={title}
                                description={description}
                                className="shadow-lg"
                            />
                        </AlertTransition>
                    ))}
                </AnimatePresence>
            </div>
        </AlertContext.Provider>   
    );
};